/**
 * Copyright 2025 Google LLC. This software is provided as-is, without warranty 
 * or representation for any use or purpose. Your use of it is subject to your 
 * agreement with Google.
 */
import { Component, EventEmitter, Input, Output, SimpleChanges, signal, ElementRef, ViewChild } from '@angular/core';
import { GuidelineService } from '../services/guideline.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-fuq',
  standalone: true,
  imports: [MatExpansionModule, MatIconModule, NgIf, NgFor, NgClass],
  templateUrl: './fuq.component.html',
  styleUrl: './fuq.component.scss'
})
export class FuqComponent {
  readonly panelOpenFUQState = signal(false);
  showArrowUpIcon: boolean = true;
  expectedQuestionsIndices = [1, 2, 3];
  isFuqResponseLoading: boolean = true;
  shouldShowSuggestions: boolean = true;
  enableScroll: boolean = false;
  disableFuqs: boolean = false;
  private destroy$ = new Subject<void>();
  @Input('FUQResponse') FUQResponse: any;
  @Input('FUQError') FUQError: any;
  @Output() question = new EventEmitter<string>();
  @Output() panelFUQStateUpdated = new EventEmitter<number>();
  @ViewChild('fuqPanel', { read: ElementRef }) fuqPanel!: ElementRef;

  constructor(public guidelineServ: GuidelineService) {
    this.guidelineServ.disableFuqPanels$
      .pipe(takeUntil(this.destroy$))
      .subscribe((state: boolean) => this.disableFuqs = state)
  }

  ngOnChanges(changes?: SimpleChanges) {
    this.isFuqResponseLoading = undefined == this.FUQResponse && undefined == this.FUQError;
    this.shouldShowSuggestions = this.isFuqResponseLoading || (this.FUQResponse?.fuqs?.length > 0 && !this.FUQError) || this.FUQError;
  }
  scrollToLatestText() {
    const beforeScrollY = window.scrollY; // Get initial scroll position
    this.fuqPanel?.nativeElement.scrollIntoView({ behavior: 'smooth' });
    setTimeout(() => {
      const afterScrollY = window.scrollY; // Get new scroll position
      if (beforeScrollY === afterScrollY) {
        this.enableScroll = false;
      }
    }, 500); // Wait for smooth scrolling to complete
  }
  ngAfterViewChecked() {
    if (this.enableScroll) {
      this.scrollToLatestText()
    }
  }
  onFUQOpen() {
    this.panelOpenFUQState.set(true);
    this.showArrowUpIcon = true;
    this.enableScroll = true;
  }

  onFUQClose() {
    this.panelOpenFUQState.set(false);
    this.showArrowUpIcon = false;
  }

  onClickFUQ(query: string) {
    if (!this.disableFuqs) {
      this.question.emit(query);
    }
    this.guidelineServ.setDisableFuqPanels(true);
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
